import AlarmsIcon from './component'

export default AlarmsIcon
